<template>
    <div class="navbar navbar-expand-md navbar-light">
		<div class="text-center d-md-none w-100">
			<button type="button" class="navbar-toggler dropdown-toggle" @click="isMobileNavOpen = !isMobileNavOpen">
				<i class="icon-unfold mr-2"></i>
				{{ $t('navbar.second.navigation') }}
			</button>
		</div>

		<div class="navbar-collapse collapse" :class="{ show: isMobileNavOpen }" id="navbar-navigation">
			<ul class="navbar-nav navbar-nav-highlight">
				<NavItem v-for="navItem in SecondNavBarJSON.left" class="dropdown">
					<NavItemLink
						:class="navItem.children.length ? 'dropdown-toggle' : null"
						:is-dropdown-toggle="navItem.children.length > 0"
						:href="generateUrlForNavItem(navItem)"
					>
						<i v-if="navItem.icon" :class="[navItem.icon, 'mr-2']"></i>
						{{ $t(navItem.name) }}
					</NavItemLink>

					<DropDownMenu v-if="navItem.children.length">
						<slot v-for="children in navItem.children">
							<DropDownMenuSubmenu v-if="children.children.length">
								<RouterLinkDropDownMenuItem
									v-if="children?.link"
									class="dropdown-toggle"
									:href="generateUrlForNavItem(children)"
								>
									<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
									{{ $t(children.name) }}
								</RouterLinkDropDownMenuItem>
								<DefaultLinkDropDownMenuItem
									v-else
									class="dropdown-toggle"
									:href="generateUrlForNavItem(children)"
								>
									<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
									{{ $t(children.name) }}
								</DefaultLinkDropDownMenuItem>
								<DropDownMenu>
									<template v-for="child in children.children">
										<RouterLinkDropDownMenuItem v-if="child?.link" :href="generateUrlForNavItem(child)">
											<i v-if="child.icon" :class="[child.icon, 'mr-2']"></i>
											{{ $t(child.name) }}
										</RouterLinkDropDownMenuItem>
										<DefaultLinkDropDownMenuItem v-else :href="generateUrlForNavItem(child)">
											<i v-if="child.icon" :class="[child.icon, 'mr-2']"></i>
											{{ $t(child.name) }}
										</DefaultLinkDropDownMenuItem>
									</template>
								</DropDownMenu>
							</DropDownMenuSubmenu>
							<RouterLinkDropDownMenuItem v-else-if="children?.link" :href="generateUrlForNavItem(children)">
								<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
								{{ $t(children.name) }}
							</RouterLinkDropDownMenuItem>
							<DefaultLinkDropDownMenuItem v-else :href="generateUrlForNavItem(children)">
								<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
								{{ $t(children.name) }}
							</DefaultLinkDropDownMenuItem>
						</slot>
					</DropDownMenu>
				</NavItem>
			</ul>

			<ul class="navbar-nav navbar-nav-highlight ml-md-auto">
				<NavItem v-for="navItem in SecondNavBarJSON.right" class="dropdown">
					<NavItemLink
						:class="navItem.children.length ? 'dropdown-toggle' : null"
						:is-dropdown-toggle="navItem.children.length > 0"
						:href="generateUrlForNavItem(navItem)"
					>
						<i v-if="navItem.icon" :class="[navItem.icon, 'mr-2']"></i>
						{{ $t(navItem.name) }}
					</NavItemLink>

					<DropDownMenu v-if="navItem.children.length">
						<slot v-for="children in navItem.children">
							<DropDownMenuSubmenu v-if="children.children.length" left>
								<RouterLinkDropDownMenuItem
									v-if="children?.link"
									class="dropdown-toggle"
									:href="generateUrlForNavItem(children)"
								>
									<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
									{{ $t(children.name) }}
								</RouterLinkDropDownMenuItem>
								<DefaultLinkDropDownMenuItem
									v-else
									class="dropdown-toggle"
									:href="generateUrlForNavItem(children)"
								>
									<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
									{{ $t(children.name) }}
								</DefaultLinkDropDownMenuItem>
								<DropDownMenu>
									<template v-for="child in children.children">
										<RouterLinkDropDownMenuItem v-if="child?.link" :href="generateUrlForNavItem(child)">
											<i v-if="child.icon" :class="[child.icon, 'mr-2']"></i>
											{{ $t(child.name) }}
										</RouterLinkDropDownMenuItem>
										<DefaultLinkDropDownMenuItem v-else :href="generateUrlForNavItem(child)">
											<i v-if="child.icon" :class="[child.icon, 'mr-2']"></i>
											{{ $t(child.name) }}
										</DefaultLinkDropDownMenuItem>
									</template>
								</DropDownMenu>
							</DropDownMenuSubmenu>
							<RouterLinkDropDownMenuItem v-else-if="children?.link" :href="generateUrlForNavItem(children)">
								<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
								{{ $t(children.name) }}
							</RouterLinkDropDownMenuItem>
							<DefaultLinkDropDownMenuItem v-else :href="generateUrlForNavItem(children)">
								<i v-if="children.icon" :class="[children.icon, 'mr-2']"></i>
								{{ $t(children.name) }}
							</DefaultLinkDropDownMenuItem>
						</slot>
					</DropDownMenu>
				</NavItem>
			</ul>
		</div>
	</div>
</template>
<script>
import NavItem from "../../../components/navbar/AppNavItem.vue";
import NavItemLink from "../../../components/navbar/AppNavItemLink.vue";
import DropDownMenu from "../../../components/dropdown/AppDropDownMenu.vue";
import RouterLinkDropDownMenuItem from "../../../components/dropdown/RouterLinkDropDownMenuItem.vue";
import DefaultLinkDropDownMenuItem from "../../../components/dropdown/DefaultLinkDropDownMenuItem.vue";
import DropDownMenuSubmenu from "../../../components/dropdown/AppDropDownMenuSubmenu.vue";

import SecondNavBarJSON from "../../../data/navbarMenu.json";
import {generateUrl} from "../../../../utils";
import { mapGetters } from 'vuex';
export default {
    name: 'SecondNavBar',
	components: {
		NavItem, NavItemLink, DropDownMenu, RouterLinkDropDownMenuItem, DefaultLinkDropDownMenuItem, DropDownMenuSubmenu
	},
	data() {
		return {
			SecondNavBarJSON,
			isMobileNavOpen: false
		}
	},
    methods: {
        generateUrlForNavItem(navItem)
        {
            if (!navItem?.link) {
                return '#';
            }

            return generateUrl(`app/projects/${this.project.uuid}/${navItem.link}`, this.project.alias)
        },
    },
    computed: {
        ...mapGetters('route', ['project'])
    },
};
</script>
